import { createContext, FC, PropsWithChildren, useContext } from "react";
import { useMeApi } from "../http/me/api";
import { LanguageCode } from "../types";

export type PermissionContextType = {
  preferredLanguage: LanguageCode | null;
  isLoading: boolean;
  hasAccess: boolean;
  isWarehouseOperator: boolean;
  isPurchaseOffice: boolean;
  hasUserMananagement: boolean;
  requestsDelete: boolean;
  editClosedRequests: boolean;
  error: boolean;
};

const PermissionContext = createContext<PermissionContextType>(undefined!);

type PermissionProviderProps = PropsWithChildren<{}>;

const PermissionProvider: FC<PermissionProviderProps> = ({ children }) => {
  const meApi = useMeApi();

  const { data, error } = meApi.useSettings();

  const contextValue: PermissionContextType = {
    isLoading: !data && !error,
    preferredLanguage: data?.preferredLanguage ?? null,
    hasAccess: !!(data?.permissions.length || data?.roles.length),
    isWarehouseOperator: !!data?.roles.some((x) => x.name === "warehouse-operator"),
    isPurchaseOffice: !!data?.roles.some((x) => x.name === "purchase-office"),
    hasUserMananagement: !!data?.permissions.some((x) => x === "user-management"),
    editClosedRequests: !!data?.permissions.some((x) => x === "edit-closed-requests"),
    requestsDelete: !!data?.permissions.some((x) => x === "delete-requests"),
    error: !!error,
  };
  return <PermissionContext.Provider value={contextValue}>{children}</PermissionContext.Provider>;
};

export const usePermissionsContext = () => {
  return useContext(PermissionContext);
};

export default PermissionProvider;
